// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"430":"19ee9590","791":"2c5aedff"}[chunkId] + ".chunk.css";
};